export default "__VITE_ASSET__BqUjNcxy__"